import request from 'utils/request'
import { MCAJS010QueryRequest } from 'types/MCAJS010/MCAJS010QueryRequest'

export const getInitListRequest = (apidata: MCAJS010QueryRequest) =>
  request({
    url: `/MCAJS010/init`,
    method: 'post',
    data: apidata,
  })
